/**
 * Cart Pubblienne — Optimistic UI v4
 *
 * All qty/price updates happen INSTANTLY on click.
 * Remove buttons instantly hide the row.
 * Dawn syncs with server in background and re-renders the product list.
 */
(function(){
  'use strict';

  /* Quantita desiderata per riga (sopravvive ai re-render, chiave = data-index) */
  var pubDesired = {};
  var pubTimer = {};

  /* ── Money formatting (Italian) ── */
  function fmt(cents){
    var abs = Math.abs(Math.round(cents));
    var eur = Math.floor(abs / 100);
    var ct = String(abs % 100).padStart(2, '0');
    var s = eur.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ct;
    return (cents < 0 ? '-' : '') + '\u20AC' + s;
  }

  function parse(str){
    if (!str) return 0;
    var c = str.replace(/[^\d.,-]/g, '');
    var p = c.split(',');
    if (p.length === 2) return Math.round(parseFloat(p[0].replace(/\./g, '') + '.' + p[1]) * 100) || 0;
    return Math.round(parseFloat(c.replace(/\./g, '')) * 100) || 0;
  }

  /* ── Recalc all summaries ── */
  function recalc(){
    var tot = 0, cnt = 0;
    document.querySelectorAll('.cart-pub__p-row:not(.cart-pub__p-row--removing)').forEach(function(r){
      var q = r.querySelector('.cart-pub__qty-val');
      var t = r.querySelector('.cart-pub__p-total');
      if (!q || !t) return;
      var qty = parseInt(q.value) || 0;
      cnt += qty;
      // Riga scontata = "<s>pieno</s> finale": somma solo il prezzo FINALE
      // (i text node), ignorando il vecchio prezzo barrato nello <s>.
      var oldS = t.querySelector('.cart-pub__p-total-old');
      if (oldS) {
        var finalStr = '';
        t.childNodes.forEach(function(n){ if (n.nodeType === 3) finalStr += n.textContent; });
        tot += parse(finalStr);
      } else {
        tot += parse(t.textContent);
      }
    });

    var f = fmt(tot);
    var lbl = cnt + ' articol' + (cnt === 1 ? 'o' : 'i');

    set('.cart-pub__sum-line b', f);
    set('.cart-pub__sum-total-value', f + ' EUR');
    set('.cart-pub__sum-head span', lbl);
    set('.cart-pub__eyebrow', 'Il tuo ordine \u00B7 ' + lbl);
    set('.cart-pub__m-tot-value', f);
    set('.cart-pub__m-tot-label', 'Totale \u00B7 ' + lbl);
  }

  function set(sel, txt){
    var el = document.querySelector(sel);
    if (el) el.textContent = txt;
  }

  /* ── Prezzo unitario per scaglione (centesimi) + sconto no personalizzazione (15% di serie dal 29 ott 2026) ── */
  function tierUnit(tiers, qty, baseCents, noPerso, pct){
    var unit = baseCents;
    if (tiers){
      var type = tiers.type || 'fixed';
      var list = tiers.tiers || tiers;
      if (list && list.length){
        for (var i = 0; i < list.length; i++){
          var t = list[i];
          var mx = (t.max === null || t.max === undefined) ? Infinity : t.max;
          if (qty >= t.min && qty <= mx){
            var val = (t.value != null) ? t.value : t.price;
            unit = (type === 'percent')
              ? Math.round(baseCents * (1 - parseFloat(val) / 100))
              : Math.round(parseFloat(val) * 100);
            break;
          }
        }
      }
    }
    if (noPerso) unit = Math.round(unit * (100 - ((pct > 0 && pct <= 100) ? pct : 15)) / 100);
    return unit;
  }
  /* Percentuale dello sconto "senza stampa" della riga: attributo data-noperso-pct scritto dal carrello (proprieta' _extra_discount_pct); 15 se manca */
  function rowNoPersoPct(input){
    var p = parseFloat(input.getAttribute('data-noperso-pct'));
    return (p > 0 && p <= 100) ? p : 15;
  }

  /* ── Gruppo di scaglione: righe con stesso prodotto e stesso lotto (data-tier-group), campioni esclusi ── */
  function groupInputs(input){
    var pid = input.getAttribute('data-product-id') || '';
    var grp = input.getAttribute('data-tier-group') || '';
    var out = [];
    document.querySelectorAll('.cart-pub__p-row:not(.cart-pub__p-row--removing) .cart-pub__qty-val').forEach(function(i){
      if (i.getAttribute('data-campione') === 'true') return;
      if ((i.getAttribute('data-product-id') || '') !== pid) return;
      if ((i.getAttribute('data-tier-group') || '') !== grp) return;
      out.push(i);
    });
    return out;
  }
  /* ── Scaglione per colore con soglia (20 ott 2026, seconda versione): sui prodotti con data-tier-mix le righe dello stesso
     LOTTO (parte di data-tier-group prima di "~") hanno ogni colore col suo scaglione se i colori sono 2 o più e NESSUN colore
     raggiunge da solo il secondo scaglione; altrimenti lo scaglione è sul totale del lotto.
     Stessa regola della scheda prodotto; pubRebalanceLots riscrive _tier_group sul server con la stessa logica. ── */
  function isMix(input){ return input.getAttribute('data-tier-mix') === 'true'; }
  function lotBase(g){ return String(g || '').split('~')[0]; }
  function mixThreshold(tiers){
    var list = tiers ? (tiers.tiers || tiers) : null;
    return (list && list.length > 1) ? (parseInt(list[1].min, 10) || 0) : Infinity;
  }
  function lotInputs(input){
    var pid = input.getAttribute('data-product-id') || '';
    var lot = lotBase(input.getAttribute('data-tier-group'));
    var out = [];
    if (!lot) return groupInputs(input);
    document.querySelectorAll('.cart-pub__p-row:not(.cart-pub__p-row--removing) .cart-pub__qty-val').forEach(function(i){
      if (i.getAttribute('data-campione') === 'true') return;
      if ((i.getAttribute('data-product-id') || '') !== pid) return;
      if (lotBase(i.getAttribute('data-tier-group')) !== lot) return;
      out.push(i);
    });
    return out;
  }
  /* { separate, total } del lotto, con la quantità di `input` sostituita da ownQty */
  function mixState(input, ownQty){
    var inputs = lotInputs(input), colors = 0, total = 0, max = 0;
    inputs.forEach(function(i){ var q = (i === input) ? ownQty : (parseInt(i.value) || 0); if (q > 0) { colors++; total += q; if (q > max) max = q; } });
    var tr = null; var raw = input.getAttribute('data-tiers');
    if (raw) { try { tr = JSON.parse(raw); } catch(e){ tr = null; } }
    var thr = mixThreshold(tr);
    return { inputs: inputs, separate: colors >= 2 && max < thr, total: total };
  }
  function groupQuantity(input, ownQty){
    if (input.getAttribute('data-campione') === 'true') return ownQty;
    if (isMix(input)) { var st = mixState(input, ownQty); return st.separate ? ownQty : (st.total || ownQty); }
    var sum = 0;
    groupInputs(input).forEach(function(i){ sum += (i === input) ? ownQty : (parseInt(i.value) || 0); });
    return sum || ownQty;
  }
  /* Le altre righe del gruppo prendono lo stesso scaglione (qty propria × nuovo unitario) */
  function repriceGroupSiblings(input, groupQty){
    var mixSt = isMix(input) ? mixState(input, parseInt(input.value) || 0) : null;
    (mixSt ? mixSt.inputs : groupInputs(input)).forEach(function(i){
      if (i === input) return;
      var row = i.closest('.cart-pub__p-row'); if (!row) return;
      var q = parseInt(i.value) || 0;
      var base = parseInt(i.getAttribute('data-base-cents')); if (isNaN(base)) return;
      var np = i.getAttribute('data-noperso') === 'true';
      var tr = null; var raw = i.getAttribute('data-tiers');
      if (raw) { try { tr = JSON.parse(raw); } catch(e){ tr = null; } }
      var gq = mixSt ? (mixSt.separate ? q : mixSt.total) : groupQty;
      var u = tierUnit(tr, gq, base, np, rowNoPersoPct(i));
      var t = row.querySelector('.cart-pub__p-total');
      var w = row.querySelector('.cart-pub__p-unit');
      if (t) t.innerHTML = (u < base) ? '<s class="cart-pub__p-total-old">' + fmt(base * q) + '</s> ' + fmt(u * q) : fmt(u * q);
      if (w) w.innerHTML = (u < base) ? '<s class="cart-pub__p-unit-old">' + fmt(base) + '</s> <b>' + fmt(u) + '</b>' : 'Prezzo unitario · <b>' + fmt(u) + '</b>';
    });
  }
  /* Intestazione lotto: aggiorna "N pz" (righe principali del lotto, companion esclusi) */
  function updateLotHeader(input){
    // Scaglione per colore (19 ott 2026): _tier_group "<lotto>~<variante>", l'intestazione è del lotto (parte prima di "~")
    var grp = (input.getAttribute('data-tier-group') || '').split('~')[0];
    if (!grp) return;
    var head = null;
    document.querySelectorAll('.cart-pub__lot-head').forEach(function(h){ if (h.getAttribute('data-lot-group') === grp) head = h; });
    if (!head) return;
    var pcs = 0;
    document.querySelectorAll('.cart-pub__p-row:not(.cart-pub__p-row--removing) .cart-pub__qty-val').forEach(function(i){
      if ((i.getAttribute('data-tier-group') || '').split('~')[0] !== grp) return;
      if (i.getAttribute('data-campione') === 'true') return;
      var row = i.closest('.cart-pub__p-row');
      // Le righe companion (seconda stampa, colori, piega, ricamo, retro) hanno il titolo senza link: non contano come pezzi
      if (row && !row.querySelector('.cart-pub__p-title a')) return;
      pcs += parseInt(i.value) || 0;
    });
    var el = head.querySelector('[data-lot-pcs]');
    if (el) el.textContent = pcs + ' pz';
  }

  /* ── Sync UNA volta sola al server (al termine dei click) ──
     Invia la quantita finale, poi re-renderizza items+footer dal server
     in modo controllato. Niente messaggi "You can only add X" da race. ── */
  function syncLine(line){
    var qty = pubDesired[line];
    if (qty == null) return;

    var itemsWrap = document.getElementById('main-cart-items');
    var sectionId = itemsWrap ? itemsWrap.dataset.id : null;
    var body = { line: line, quantity: qty, sections_url: window.location.pathname };
    if (sectionId) body.sections = [sectionId];

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r){ return r.json(); })
    .then(function(state){
      if (!state || state.status) return;              // errore: lascia stato ottimistico
      if (state.item_count === 0) { location.reload(); return; }
      if (state.sections && sectionId && state.sections[sectionId]) {
        var doc = new DOMParser().parseFromString(state.sections[sectionId], 'text/html');
        var ni = doc.querySelector('.js-contents-items');
        var nf = doc.querySelector('.js-contents-footer');
        var ci = document.querySelector('.js-contents-items');
        var cf = document.querySelector('.js-contents-footer');
        if (ni && ci) ci.innerHTML = ni.innerHTML;
        if (nf && cf) cf.innerHTML = nf.innerHTML;     // footer = totali reali (sconti inclusi)
      }
      // Click avvenuti durante la richiesta: il desiderato e cambiato -> riallinea e ri-sincronizza
      var srvQty = (state.items && state.items[line - 1]) ? state.items[line - 1].quantity : null;
      if (srvQty != null && pubDesired[line] !== srvQty) {
        var ni2 = document.getElementById('Quantity-' + line);
        if (ni2) { ni2.value = pubDesired[line]; }
        recalc();
        syncLine(line);
      } else {
        recalc();
        pubRebalanceLots();
      }
    })
    .catch(function(){});
  }

  /* ── Riallineo delle etichette _tier_group dei lotti "scaglione per colore con soglia" (20 ott 2026) ──
     Dopo ogni modifica confermata dal server (quantità o rimozione) rilegge /cart.js, ricalcola per ogni lotto dei
     prodotti con data-tier-mix se i colori vanno contati separati o insieme e, se un'etichetta è cambiata, la riscrive
     con /cart/change.js (stessa chiamata delle quantità, proprietà complete della riga). Poi ridisegna il carrello dal
     server. Così la Function dello sconto, che legge solo l'etichetta, applica sempre la regola della scheda prodotto. ── */
  var pubRebalancing = false, pubRebalanceAgain = false;
  function pubRebalanceLots(){
    var cfg = {};
    document.querySelectorAll('.cart-pub__qty-val[data-tier-mix="true"]').forEach(function(i){
      var pid = i.getAttribute('data-product-id'); if (!pid || cfg[pid]) return;
      var tr = null; var raw = i.getAttribute('data-tiers');
      if (raw) { try { tr = JSON.parse(raw); } catch(e){ tr = null; } }
      cfg[pid] = { thr: mixThreshold(tr) };
    });
    if (!Object.keys(cfg).length) return;
    if (pubRebalancing) { pubRebalanceAgain = true; return; }
    pubRebalancing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var lots = {};
        (cart.items || []).forEach(function(it){
          var pid = String(it.product_id); if (!cfg[pid]) return;
          var p = it.properties || {};
          if (p['Campione'] === 'Sì' || Object.prototype.hasOwnProperty.call(p, 'Riferito a')) return;
          var lot = lotBase(p['_tier_group']); if (!lot) return;
          var k = pid + '|' + lot;
          (lots[k] = lots[k] || { pid: pid, lot: lot, items: [] }).items.push(it);
        });
        var changes = [];
        Object.keys(lots).forEach(function(k){
          var L = lots[k], colors = {}, max = 0;
          L.items.forEach(function(it){ if (it.quantity > 0) { colors[it.variant_id] = (colors[it.variant_id] || 0) + it.quantity; } });
          Object.keys(colors).forEach(function(v){ if (colors[v] > max) max = colors[v]; });
          var separate = Object.keys(colors).length >= 2 && max < cfg[L.pid].thr;
          L.items.forEach(function(it){
            var want = separate ? L.lot + '~' + it.variant_id : L.lot;
            if ((it.properties || {})['_tier_group'] !== want) changes.push({ item: it, group: want });
          });
        });
        if (!changes.length) return null;
        // Una riscrittura alla volta; l'ultima chiede anche la sezione del carrello già ridisegnata dal server
        var itemsWrap = document.getElementById('main-cart-items');
        var sectionId = itemsWrap ? itemsWrap.dataset.id : null;
        // La chiave di riga va riletta dal carrello restituito dalla riscrittura precedente (dopo un cambio di proprietà
        // Shopify può non accettare più la chiave letta prima); in caso di errore un secondo tentativo dopo rilettura di /cart.js.
        function findKey(cart, c){
          var hit = (cart && cart.items || []).filter(function(it){ return it.variant_id === c.item.variant_id && (it.properties || {})['_tier_group'] === (c.item.properties || {})['_tier_group']; })[0];
          return hit ? hit.key : c.item.key;
        }
        function sendChange(c, cart, last){
          var props = {}; Object.keys(c.item.properties || {}).forEach(function(k){ props[k] = c.item.properties[k]; });
          props['_tier_group'] = c.group;
          var body = { id: findKey(cart, c), quantity: c.item.quantity, properties: props };
          if (last && sectionId) { body.sections = [sectionId]; body.sections_url = window.location.pathname; }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function(r){ return r.json(); });
        }
        var chain = Promise.resolve(cart);
        changes.forEach(function(c, idx){
          var last = idx === changes.length - 1;
          chain = chain.then(function(prev){
            return sendChange(c, prev, last).then(function(state){
              if (state && state.status) {
                return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); })
                  .then(function(fresh){ return sendChange(c, fresh, last); });
              }
              return state;
            }).then(function(state){
              if (window.console && console.debug) console.debug('[pubMix] riga', c.item.variant_title, '->', c.group, state && state.status ? ('ERRORE ' + (state.description || state.message)) : 'ok');
              return state;
            });
          });
        });
        return chain.then(function(state){ return { state: state, sectionId: sectionId }; });
      })
      .then(function(res){
        if (!res) return;
        var state = res.state, sectionId = res.sectionId;
        if (!state || state.status || !sectionId || !state.sections || !state.sections[sectionId]) { location.reload(); return; }
        var doc = new DOMParser().parseFromString(state.sections[sectionId], 'text/html');
        var ni = doc.querySelector('.js-contents-items');
        var nf = doc.querySelector('.js-contents-footer');
        var ci = document.querySelector('.js-contents-items');
        var cf = document.querySelector('.js-contents-footer');
        if (ni && ci) ci.innerHTML = ni.innerHTML;
        if (nf && cf) cf.innerHTML = nf.innerHTML;
        // Gli indici di riga possono essere cambiati: azzera le sync in coda
        Object.keys(pubTimer).forEach(function(k){ clearTimeout(pubTimer[k]); });
        pubTimer = {}; pubDesired = {};
        recalc();
      })
      .catch(function(){})
      .then(function(){
        pubRebalancing = false;
        if (pubRebalanceAgain) { pubRebalanceAgain = false; pubRebalanceLots(); }
      });
  }
  // Rimozione di una riga: la sincronizza Dawn (cart-remove-button), che a fine lavoro pubblica cartUpdate
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(ev){ if (ev && ev.source === 'cart-items') pubRebalanceLots(); });
  }

  /* ── Handle remove button click (capture phase) ── */
  document.addEventListener('click', function(ev){
    var removeBtn = ev.target.closest('.cart-pub__p-remove');
    if (!removeBtn) return;
    var row = removeBtn.closest('.cart-pub__p-row');
    if (!row) return;

    // Instantly hide the row with animation
    row.classList.add('cart-pub__p-row--removing');
    row.style.overflow = 'hidden';
    row.style.transition = 'opacity .25s, max-height .3s .05s';
    row.style.opacity = '0';
    row.style.maxHeight = row.offsetHeight + 'px';
    requestAnimationFrame(function(){
      row.style.maxHeight = '0';
    });

    // Also hide the error row if present
    var errorRow = row.nextElementSibling;
    if (errorRow && errorRow.classList.contains('cart-pub__p-error')) {
      errorRow.style.display = 'none';
    }

    // Annulla TUTTE le sync +/- in coda: dopo la rimozione gli indici riga
    // shiftano, quindi una syncLine ritardata ri-aggiungerebbe/sbaglierebbe riga.
    Object.keys(pubTimer).forEach(function(k){ clearTimeout(pubTimer[k]); });
    pubTimer = {};
    pubDesired = {};

    // Recalc summaries immediately (row excluded via --removing class)
    recalc();

    // Let the event bubble to CartRemoveButton which handles server sync
  }, true);

  /* ── Handle +/- click (capture phase, runs before Dawn) ── */
  document.addEventListener('click', function(ev){
    var btn = ev.target.closest('[name="plus"], [name="minus"]');
    if (!btn) return;
    var row = btn.closest('.cart-pub__p-row');
    if (!row) return;
    var input = row.querySelector('.cart-pub__qty-val');
    if (!input) return;

    var action = btn.name;
    var cur = parseInt(input.value) || 0;
    var step = parseInt(input.step) || 1;
    var mn = parseInt(input.min) || 0;
    var mx = input.max ? parseInt(input.max) : 999999;
    var nxt = action === 'plus' ? Math.min(cur + step, mx) : Math.max(cur - step, mn);

    if (nxt === cur) return;

    // 1. Update input value + memorizza desiderato per riga
    input.value = nxt;
    pubDesired[input.dataset.index] = nxt;

    // 2. Update line total con il prezzo SCAGLIONE corretto per la nuova qty
    var totalEl = row.querySelector('.cart-pub__p-total');
    var unitWrap = row.querySelector('.cart-pub__p-unit');
    var baseCents = parseInt(input.getAttribute('data-base-cents'));
    if (isNaN(baseCents)) {
      var ub = row.querySelector('.cart-pub__p-unit b');
      baseCents = ub ? parse(ub.textContent) : 0;
    }
    var noPerso = input.getAttribute('data-noperso') === 'true';
    var tiers = null;
    var traw = input.getAttribute('data-tiers');
    if (traw) { try { tiers = JSON.parse(traw); } catch(e){ tiers = null; } }

    // Scaglione sulla quantità del GRUPPO (stesso prodotto + stesso lotto _tier_group; senza lotto = tutto il
    // prodotto): stessa regola del Liquid e della Function. Le altre righe del gruppo si aggiornano insieme.
    var groupQty = groupQuantity(input, nxt);
    var unit = tierUnit(tiers, groupQty, baseCents, noPerso, rowNoPersoPct(input));
    var lc = unit * nxt;

    if (totalEl){
      if (unit < baseCents){
        totalEl.innerHTML = '<s class="cart-pub__p-total-old">' + fmt(baseCents * nxt) + '</s> ' + fmt(lc);
      } else {
        totalEl.textContent = fmt(lc);
      }
    }
    if (unitWrap){
      if (unit < baseCents){
        unitWrap.innerHTML = '<s class="cart-pub__p-unit-old">' + fmt(baseCents) + '</s> <b>' + fmt(unit) + '</b>';
      } else {
        unitWrap.innerHTML = 'Prezzo unitario · <b>' + fmt(unit) + '</b>';
      }
    }
    repriceGroupSiblings(input, groupQty);
    updateLotHeader(input);

    // 3. Recalc summaries
    recalc();

    // 4. Prevent Dawn from also stepping (we already changed the value)
    ev.stopImmediatePropagation();
    ev.preventDefault();

    // 5. Sync UNA volta sola dopo l'ultimo click (debounce per riga).
    var ln = input.dataset.index;
    clearTimeout(pubTimer[ln]);
    pubTimer[ln] = setTimeout(function(){ syncLine(ln); }, 500);

  }, true); // capture phase

  /* ── Clamp manuale al minimo custom e al multiplo (prima della sync Dawn) ──
     25 set 2026: un valore digitato che non rispetta il multiplo (contato da zero o dal minimo)
     viene portato al multiplo successivo, come fa la scheda prodotto. ── */
  document.addEventListener('change', function(ev){
    var input = ev.target;
    if (!input || !input.classList || !input.classList.contains('cart-pub__qty-val')) return;
    var cmin = parseInt(input.getAttribute('data-cmin')) || parseInt(input.min) || 1;
    var cstep = parseInt(input.getAttribute('data-step')) || parseInt(input.step) || 1;
    var val = parseInt(input.value);
    if (isNaN(val) || val < cmin) {
      input.value = cmin;
    } else if (cstep > 1 && val % cstep !== 0 && (val - cmin) % cstep !== 0) {
      input.value = cmin + Math.ceil((val - cmin) / cstep) * cstep;
    }
  }, true); // capture: prima del handler Dawn

})();
